<template>
  <div class="s-layout" :style="colorObject">
    <Loading v-if="isLoading" loading-message="載入中..." :background-color="'#ffffff'" />

    <div class="s-container">
      <div class="content" :style="colors">
        <div class="custom-elanco-header">
          <span class="custom-elanco-header__text">Hi {{ deepGet(user, 'name') }}</span>
          <a :href="deepGet(event, 'config.header_logo_url', '#')">
            <img v-if="deepGet(event, 'config.images.header_logo')" :src="deepGet(event, 'config.images.header_logo')"
              class="custom-elanco-header__image ml-3">
          </a>
        </div>


        <div class="scanner-view">
          <div class="scanner-view__body">
            <div class="scanner-view__title mb-3">請將 QR code 對準框線</div>
            <QRCodeScanner @onScan="handleQrCodeIsScanned" :qrbox="qrbox" ref="qrScanner"
              class="scanner-view__scanner" />
            <button class="scanner-view__close s-btn s-btn-outline-primary s-btn-xs mt-3" type="button"
              @click="handleCloseScannerButtonIsClicked">
              取消
            </button>
          </div>
        </div>


        <!-- page: empty message end-->
      </div>
    </div>
  </div>
</template>

<script>
// Packages
import { mapGetters } from "vuex";
import deepGet from "lodash/get";
// Waltily Utils
import { themeColorFn } from "@/mixins/liff/themeColor";
import dateOptionMixin from "@/mixins/liff/dateOption";
// Components
import Loading from "@/components/Page/Liff/Shared/Loading";
import QRCodeScanner from "@/components/QRCodeScanner.vue";
// Api
import redeemApi from "@/apis/liff/v2/redeem";



export default {
  mixins: [
    themeColorFn({ themeConfigPage: 'redeem' }),
    dateOptionMixin,
  ],
  components: {
    Loading,    
    QRCodeScanner,
  },
  mounted() {
    if (this.$route.query.event_code) {
      this.eventCode = this.$route.query.event_code;
    } else {
      this.$swal({
        text: '網址錯誤，沒有活動代碼',
        confirmButtonText: '確定',
      })
      
      return;
    }

    if (this.$route.params.code) {
      this.code = this.$route.params.code;
    } 

    this.fetchEvent();
  },
  data() {
    return {
      isLoading: false,
      qrbox: {
        width: 200,
        height: 200,
      },
      
      eventCode: null,
      event: {
        config: {},
      },
      code: null,      
      branchId: null,
      branchCode: '',
      branchProvider: '',
      isRedeemSuccess: false,
      hasError: false,
      oldFriendMessage: '',      
      error_message: [],
    };
  },
  computed: {
    ...mapGetters({
      meta: "liffGeneral/meta",
      themeConfig: "liffGeneral/themeConfig",
    }),
    ...mapGetters("liffAuth", ["user"]),
    colors() {
      return {
        "--header_bg_color": this.event.config.header_bg_color,
        "--header_text_color": this.event.config.header_text_color,
        "--submit_bg_color": this.event.config.submit_bg_color,
        "--submit_text_color": this.event.config.submit_text_color,
      }
    },
  },

  methods: {
    deepGet,    
    async fetchEvent() {
      try {
        this.isLoading = true;

        const eventRes = await redeemApi.getRedeemEvent({
          event_code: this.eventCode,
        });

        this.event = eventRes.data.data.event;
        this.error_message = eventRes.data.data.event.config.error_message ?? [];
        

        
      } catch (error) {
        console.error(error);
        this.hasError = true;
        if (error.response?.status === 400) {
          const errorMessageConfig = this.findMappedError(error.response.data.message);
          this.$swal({
            text: deepGet(errorMessageConfig, 'message', '設定錯誤'),
            confirmButtonText: '確定',
          })
        } else {
          this.$swal({
            text: '活動資訊讀取失敗',
            confirmButtonText: '確定',
          })
        }
      } finally {
        this.isLoading = false;
      }
    },   
    findMappedError(code) {
      const errorMessageConfig = this.error_message ?? [];
      return errorMessageConfig.find(item => item.code === code);
    },
    
    isValidUrl(string) {
      try {
        new URL(string);
        return true;
      } catch (_) {
        return false;
      }
    },
    async handleQrCodeIsScanned(decodedText) {
      if (!this.isValidUrl(decodedText)) {
        this.$swal({
          text: '掃描結果不是有效的 URL',
          confirmButtonText: '確定',
        })
        return;
      }
      window.location = decodedText;
    },
    
    handleCloseScannerButtonIsClicked() {
      this.$refs.qrScanner.stopScanner();
      this.$router.push({ name: 'LiffProjElanco2026Redeem', query: { event_code: this.eventCode } });
    },
    
    
  }
}
</script>

<style lang="scss" scoped>


.scanner-view { 
  width: 100%;
  height: calc(100vh - 72px);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;

  &__body {
    width: 500px;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 32px;
  }

  &__title {
    font-size: 1.25rem;
    color: #555;
    text-align: center;
  }

  &__scanner {
    width: 100%;
    aspect-ratio: 1 / 1;
    background-color: #f5f5f5;
    border-radius: 8px;
    overflow: hidden;
  }
}

.custom-elanco-header {
  padding: 16px;
  background-color: var(--header_bg_color);
  color: var(--header_text_color);
  font-size: 1.25rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__image {
    height: 40px;
  }
}

.btn-container {
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
}


.content__card__bg{
    padding-bottom: 0;  
    min-height: calc(100vh - 72px);
    background: url('./images/2026/card-bg-1.jpg') no-repeat top center, 
    url('./images/2026/card-bg-2.jpg') no-repeat bottom center,
    #f4edf4; 
    background-size: 100%, 100%, 100%;
}

</style>

<style lang="scss">
@import "../../../../assets/css/liff/main.css";
@import "../../../../assets/css/liff/liff_init_theme_config.css";
@import '../../../../assets/scss/shared/components/_fields.scss';

.s-layout {
  color: var(--liff-primary_text_color);
  background-color: var(--liff-layout_bg_color);
  --s-gray: #979797 !important;
  --s-gray-light: #f0f0f0 !important;
}

.s-container {
  min-height: 100vh;
  position: relative;
  max-width: 768px;
  margin: auto;
}

.s-layout,
.s-layout *,
.s-layout *:before,
.s-layout *:after {
  --s-secondary: #de006f;
  --s-warning: #ed6c00;
  --s-danger: #fe0000;
  --s-gray-darker: #363636;
  --s-gray-dark: #2c2c2e;
  --s-gray: #979797 !important;
  --s-gray-light: #c0c4cc;
  --s-gray-lighter: #f2f2f7;
  --liff-button-color: #93bf65;
  --liff-primary_text_color: #93bf65;
  --s-primary: #93bf65;
}

.content {
  height: 100vh;
  overflow-y: auto;
  margin: 0;
  //padding-bottom: 24px;
  color: var(--liff-primary_text_color);

  &__success {
    &__title {
      font-size: 24px;
      font-weight: 600;
    }

    &__old-friend-message {
      font-size: 16px;
      color: #fe0000;
      font-weight: 500;
    }
  }

  &__card {
    padding-bottom: 0;

    background-color: var(--liff-primary_text_color);

    &__header {
      color: white;

      &__title {
        font-size: 20px;
        font-weight: 600;
      }

      &__level {
        font-size: 36px;
        font-weight: 600;
      }

      &__avatar {
        img {
          width: 110px;
          height: 110px;
        }
      }
    }

    &__remaining {
      font-size: 18px;
      font-weight: 600;
      color: var(--liff-primary_text_color);
    }


  }
}

.card {
  margin-top: 24px;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 24px;
  margin-top: 12px;

  &__info {
    color: #636366;
    line-height: 24px;
    font-size: 16px;
    padding-top: 12px;
  }
}

.s-btn-primary {
  background-color: var(--liff-button-color) !important;
}

.s-btn-outline-primary {
  border-width: 3px !important;
}

.alert-message {
  text-align: center;
  color: var(--s-danger);
  font-size: 16px;
  padding: 12px;
  margin: 0;
}
</style>
